'use client';

import Image, { ImageProps } from 'next/image';
import { useState } from 'react';

const ImageOptimizer = (props: ImageProps) => {
  const [error, setError] = useState(false);
  return (
    <Image
      {...props}
      src={props.src && !error ? props.src : '/images/empty_bg_small.svg'}
      alt={props.alt || '이미지 없음'}
      loading="lazy"
      onError={() => setError(true)}
    />
  );
};

export default ImageOptimizer;
